<template>
  <div>
    <modal :modal-key="'points-multiplier'"
           :class-style="'modal--welcomeback'" :body-style="'welcone_pad'"
           @close="$emit('close')">
      <template slot="header">
        <h1>{{ getTranslations.home_points_multiplier_header }}</h1>
        <br>
        <img class="pinicon" src="static/images/bonus_phase.svg" alt="">
      </template>
      <template slot="body">
        <h2 class="modal_sub">{{ getTranslations.home_points_multiplier_points }}</h2>
        <p>{{ getTranslations.home_points_multiplier_duration }}</p>

        <div class="bonus_phase_timer">
          <h1 v-if="counter">{{ counter }}</h1>
        </div>
        <p class="modal_prg">{{ getTranslations.home_points_multiplier_between_part_1 }}
          {{ dateStart }} - {{ dateEnd }}
          {{ getTranslations.home_points_multiplier_between_part_2 }}{{ phaseBonusModalToBeDisplayed.multiplier }}</p>
        <p class="modal_prg">{{ getTranslations.home_points_multiplier_play_now }}</p>

        <div class="new_game_buttons_section ">
          <h2>{{ getTranslations.home_points_multiplier_start_new_game }}</h2>
          <div class="btn_left"><p>{{ getTranslations.home_declined_req_random_game }}</p>
            <a style="cursor:pointer" @click.prevent="playGameMethod">
              <img src="static/images/random_icon.svg" alt=""></a>
          </div>
          <div class="btn_right">
            <p>{{ getTranslations.home_modals_profile_level_against_friend }}</p>
            <a style="cursor:pointer" @click.prevent="playFriend()">
              <img src="static/images/friend_icon.svg" alt="">
            </a>
          </div>
        </div>
      </template>
    </modal>
    <search-specific-user v-if="showSearchModal" @close="showSearchModal = false"/>
  </div>
</template>

<script>
// modal_points_multiplier.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import Modal from '@/components/home/modals/shared/GenericModal';
import NewGameMixin from '@/common/mixins/home';
import SearchSpecificUser from '../users/SearchSpecificOpponent';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-multiplier',
  mixins: [NewGameMixin],
  data() {
    return {
      showSearchModal: false,
      timer: 0,
      counter: '',
      dateStart: null,
      dateEnd: null,
    };
  },
  components: {
    SearchSpecificUser,
    Modal,
  },
  beforeDestroy() {
    this.storeModalForHomePage(null);
    this.clearPhaseBonusModalToBeDisplayed();
  },
  created() {
    moment.locale('EN');
    this.dateStart = moment(this.phaseBonusModalToBeDisplayed.start).format('hh:mm:ss');
    this.dateEnd = moment(this.phaseBonusModalToBeDisplayed.end).format('hh:mm:ss');
    const interval = 1000; // every 1 second
    let duration;
    // get time element
    // calculate difference between two times
    const eventTime = moment(this.phaseBonusModalToBeDisplayed.end);
    // loop to countdown every 1 second
    this.timer = setInterval(() => {
      // based on time set in user's computer time / OS
      const currentTime = moment(new Date());
      // get duration between two times
      duration = moment.duration(eventTime.diff(currentTime));
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');

      // if duration is >= 0
      if (currentTime.isAfter(eventTime)) {
        clearInterval(this.timer);
        // hide the countdown element
        this.counter = '';
        this.phaseBonusModalToBeDisplayed.active = false;
      } else {
        // otherwise, show the updated countdown
        this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
      }
    }, interval);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'clearPhaseBonusModalToBeDisplayed',
    ]),
    playFriend() {
      this.showSearchModal = true;
    },
    playGameMethod() {
      this.playGame();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'phaseBonusModalToBeDisplayed',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/PointsMultiplier.vue